/*

  --------- v1.03 ----------
  2024.08.18
  
  Filter the images displayed in the modal on the product information page
  
*/

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        // v1.03 begins
        const activeMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMediaAlt = this.querySelector(`[data-media-id="${activeMediaId}"]`).alt;

        // Hide images that have a different alt text (except when alt is "all")
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${activeMediaId}"])`)                 // replaced  this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          .forEach((element) => {
            if (element.alt !== activeMediaAlt && activeMediaAlt !== 'all') {
              element.classList.add('hidden');
              console.log("Hidden media element:", element.alt);
            }
            element.classList.remove('active');
          });

        const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        // v1.03 ends

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
